<template>
  <div>
    <WallkitPlanView/>
  </div>
</template>

<script>
import WallkitPlanView from "./WallkitPlanView";
export default {
  name: "WallkitPlanCreation",
  components: {WallkitPlanView}
}
</script>
